export default __webpack_public_path__ + "static/media/giantWin.4a1ea918.mp3";